import React from 'react'
import TrialExpiredModal from './trial-expired-modal'
import WelcomeFreeTrial from '../welcome-modal/welcome-modal'

interface Props {
  setJoyrideRun: any
}

export default function TrialModal({ setJoyrideRun }: Props) {
  return (
    <>
      <TrialExpiredModal />
      <WelcomeFreeTrial setJoyrideRun={setJoyrideRun} />
    </>
  )
}
